var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white border border-secondary rounded",staticStyle:{"min-height":"500px"}},[_vm._m(0),_c('div',{ref:"totalQRRegisteredByVehicleType",staticStyle:{"height":"1000px"}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-black"},[_c('h3',{staticClass:"text-right pt-2 mr-4",staticStyle:{"color":"white"}},[_vm._v("Total QR Registered By Vehicle Type")]),_c('hr')])
}]

export { render, staticRenderFns }